<template>
    <div class="command-box mt-4 flex items-center flex-wrap gap-3">
        <div class="flex items-center gap-2">
            <label class="w-20 text-right">命令类型</label>
            <el-select v-model="cmdType" placeholder="请选择" style="width: 260px" @change="loadCmdParams">
                <el-option v-for="c in cmdList" :key="c.f_ID" :label="c.f_CommandName" :value="c.f_ID" />
            </el-select>
        </div>

        <!-- 阀门控制 -->
        <div v-if="showValve" class="flex items-center gap-2">
            <label class="w-20 text-right">阀门控制</label>
            <el-select v-model="form.valve" style="width: 200px">
                <el-option label="开阀" value="1" />
                <el-option label="关阀" value="0" />
            </el-select>
        </div>

        <!-- 开关机 -->
        <div v-if="showOnOff" class="flex items-center gap-2">
            <label class="w-20 text-right">开关机</label>
            <el-select v-model="form.onOff" style="width: 200px">
                <el-option label="开机" value="1" />
                <el-option label="关机" value="0" />
            </el-select>
        </div>

        <!-- 温度（1位小数） -->
        <div v-if="showTemp" class="flex items-center gap-2">
            <label class="w-20 text-right">设置温度</label>
            <el-input-number v-model="form.temp" :step="0.1" :min="5" :max="35" style="width: 200px" />
        </div>

        <!-- 风速 -->
        <div v-if="showWind" class="flex items-center gap-2">
            <label class="w-20 text-right">风速</label>
            <el-select v-model="form.wind" style="width: 200px">
                <el-option label="自动" value="0" />
                <el-option label="低" value="1" />
                <el-option label="中" value="2" />
                <el-option label="高" value="3" />
            </el-select>
        </div>

        <!-- 运行模式 -->
        <div v-if="showMode" class="flex items-center gap-2">
            <label class="w-20 text-right">运行模式</label>
            <el-select v-model="form.mode" style="width: 200px">
                <el-option label="制冷" value="0" />
                <el-option label="制热" value="1" />
                <el-option label="送风" value="2" />
            </el-select>
        </div>

        <!-- 上报周期 -->
        <div v-if="showPeriod" class="flex items-center gap-2">
            <label class="w-20 text-right">上报周期</label>
            <el-input-number v-model="form.period" :min="1" suffix="分钟" style="width: 200px" />
        </div>

        <!-- 节能模式 -->
        <div v-if="showEnergySave" class="flex items-center gap-2">
            <label class="w-20 text-right">模式开关</label>
            <el-select v-model="form.energySave" style="width: 200px">
                <el-option label="关闭" value="0" />
                <el-option label="开启" value="1" />
            </el-select>
        </div>

        <!-- 锁定模式 -->
        <div v-if="showLockMode" class="flex items-center gap-2">
            <label class="w-20 text-right">锁定模式</label>
            <el-select v-model="form.lockMode" style="width: 200px">
                <el-option label="开关锁定" value="1" />
                <el-option label="温度锁定" value="2" />
            </el-select>
        </div>

        <!-- 温度上限 -->
        <div v-if="showTempMax" class="flex items-center gap-2">
            <label class="w-20 text-right">温度上限</label>
            <el-input-number v-model="form.tempMax" :min="5" :max="35" style="width: 200px" />
        </div>

        <!-- 温度下限 -->
        <div v-if="showTempMin" class="flex items-center gap-2">
            <label class="w-20 text-right">温度下限</label>
            <el-input-number v-model="form.tempMin" :min="5" :max="35" style="width: 200px" />
        </div>

        <!-- 外部传感器 -->
        <div v-if="showExtSensor" class="flex items-center gap-2">
            <label class="w-20 text-right">外部传感器</label>
            <el-select v-model="form.extSensor" style="width: 200px">
                <el-option label="使能" value="1" />
                <el-option label="不使能" value="0" />
            </el-select>
        </div>

        <!-- 制热启动温度 35~60 -->
        <div v-if="showHeatStartTemp" class="flex items-center gap-2">
            <label class="w-20 text-right">温度设定</label>
            <el-input-number v-model="form.heatStart" :min="35" :max="60" style="width: 200px" />
        </div>

        <!-- 制冷启动温度 7~25 -->
        <div v-if="showCoolStartTemp" class="flex items-center gap-2">
            <label class="w-20 text-right">温度设定</label>
            <el-input-number v-model="form.coolStart" :min="7" :max="25" style="width: 200px" />
        </div>

        <!-- 升级信息 -->
        <div v-if="showUpdate" class="flex items-center gap-2">
            <label class="w-20 text-right">文件路径</label>
            <el-input v-model="form.filePath" style="width: 200px" />
        </div>
        <div v-if="showUpdate" class="flex items-center gap-2">
            <label class="w-20 text-right">版本</label>
            <el-input v-model="form.fileVer" style="width: 200px" />
        </div>
        <div v-if="showUpdate" class="flex items-center gap-2">
            <label class="w-20 text-right">大小</label>
            <el-input v-model="form.fileSize" style="width: 200px" />
        </div>

        <el-button type="primary" @click="handleSend">
            <i class="el-icon-setting"></i>
            发送命令
        </el-button>
    </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'

const props = defineProps({
    cmdList: { type: Array, default: () => [] },
    meterType: [Number, String]
})

const emit = defineEmits(['send'])

const cmdType = ref('')
const form = reactive({
    valve: '',
    onOff: '',
    temp: 26,
    wind: '',
    mode: '',
    period: '',
    energySave: 0,
    lockMode: '',
    tempMax: 35,
    tempMin: 5,
    extSensor: 0,
    heatStart: 35,
    coolStart: 25,
    filePath: '',
    fileVer: '',
    fileSize: ''
})

// 命令显隐控制
const showValve = ref(false)
const showOnOff = ref(false)
const showTemp = ref(false)
const showWind = ref(false)
const showMode = ref(false)
const showPeriod = ref(false)
const showEnergySave = ref(false)
const showLockMode = ref(false)
const showTempMax = ref(false)
const showTempMin = ref(false)
const showExtSensor = ref(false)
const showHeatStartTemp = ref(false)
const showCoolStartTemp = ref(false)
const showUpdate = ref(false)

// 重置所有面板为隐藏
const resetAllPanels = () => {
    showValve.value = false
    showOnOff.value = false
    showTemp.value = false
    showWind.value = false
    showMode.value = false
    showPeriod.value = false
    showEnergySave.value = false
    showLockMode.value = false
    showTempMax.value = false
    showTempMin.value = false
    showExtSensor.value = false
    showHeatStartTemp.value = false
    showCoolStartTemp.value = false
    showUpdate.value = false
}

const loadCmdParams = () => {
    resetAllPanels()
    const id = Number(cmdType.value)

    if (id === 16) showValve.value = true
    if (id === 31) showOnOff.value = true
    if (id === 32) showTemp.value = true
    if (id === 33) showWind.value = true
    if (id === 34) showMode.value = true
    if (id === 35) showPeriod.value = true
    if (id === 36) showEnergySave.value = true
    if (id === 37) showLockMode.value = true
    if (id === 38) showTempMax.value = true
    if (id === 39) showTempMin.value = true
    if (id === 40) showExtSensor.value = true
    if (id === 41) showHeatStartTemp.value = true
    if (id === 42) showCoolStartTemp.value = true
    if (id === 99) showUpdate.value = true
}

const handleSend = () => {
    emit('send', { cmdType: cmdType.value, form: { ...form } })
    ElMessage.success('命令发送成功')
}
</script>

<style scoped>
.flex {
    display: flex;
}
.items-center {
    align-items: center;
}
.gap-2 {
    gap: 8px;
}
.gap-3 {
    gap: 12px;
}
.flex-wrap {
    flex-wrap: wrap;
}
.w-20 {
    width: 80px;
}
.text-right {
    text-align: right;
}
.mt-4 {
    margin-top: 16px;
}
</style>
